import { createGlobalStyle } from "styled-components";
import NanumSquareR from "../fonts/NanumSquareR.woff";
import NanumSquareEB from "../fonts/NanumSquareEB.woff";
import NanumSquareB from "../fonts/NanumSquareB.woff";

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    border: 0;
    box-sizing: border-box;
  }

  @font-face {
    font-family: 'NanumSquareEB';
    src: url(${NanumSquareEB});
    font-weight: 800;
  }

  @font-face {
    font-family: 'NanumSquareB';
    src: url(${NanumSquareB});
    font-weight: 700;
  }

  @font-face {
    font-family: 'NanumSquareR';
    src: url(${NanumSquareR});
    font-weight: 400;
  }

  html {
    font-size: 62.5%;
    font-family: 'NanumSquareR', sans-serif;
  }

  body {
    font-size: 1.6rem;
    font-family: inherit;
    min-width: fit-content;
    line-height: normal;
    background-color: ${({ theme }) => theme.color.purple_bg};
  }

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote::before, blockquote::after, q::before, q::after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  a {
    text-decoration: none;
  }

  button {
    cursor: pointer;
    border: none;
  }
  summary::marker {
        display: none;
        content: "";
        font-size: 0;
      }
      summary::-webkit-details-marker {
        display: none;
      }

iframe#webpack-dev-server-client-overlay{display:none!important}
.pointer{
  cursor: pointer;
}
`;

export default GlobalStyle;
